import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { contentHeaders } from './headers';
import 'rxjs/add/operator/map';
import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';
import 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class VTService {
  remotePosts = new BehaviorSubject([]);
  _router;


  //public baseUrl: string = environment.serverURL;

   //public baseUrl: string = "http://localhost:51269/";
   public baseUrl: string = "http://localhost:62048/api/"

  constructor(public http: HttpClient, router: Router) {
    this._router = router;
    
  }
  logintoVT(payload){
    return this.http.post<any>(`${this.baseUrl}api/v1/login`,payload);
  }
  ticketList(objTicket){
    return this.http.post<any>(`${this.baseUrl}api/ticket/v1/TicketList`,objTicket);
  }

  GetContactList(objContactList)
  {
    return this.http.post<any>(`${this.baseUrl}api/ticket/v1/GetContactList`,objContactList)
  }
  UpdateTicketRequester(objUpdateTicketRequester)
  {
   return this.http.post<any>(`${this.baseUrl}api/ticket/v1/UpdateTicketRequester`,objUpdateTicketRequester)
  }
  GetTicketDetails(objGetTicketDetails)
  {
    return this.http.post<any>(`${this.baseUrl}api/ticket/v1/GetTicketDetails`,objGetTicketDetails)
  }
  BulkUpdateTickets(objBulkUpdateTickets)
  {
    return this.http.post<any>(`${this.baseUrl}api/ticket/v1/BulkUpdateTickets`,objBulkUpdateTickets)
  }

  getMenuItems(queryString,body){
    return this.http.post<any>(`${this.baseUrl}Zoho/GetDashboardsForRole?${queryString}`,body)

  }
  
}